export const variantsUl = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      staggerChildren: 0.5,
      when: 'beforeChildren',
    },
  },
};

export const childVariantsUl = {
  hidden: {
    translateY: -70,
    opacity: 0,
  },
  visible: {
    translateY: 0,
    opacity: 1,
  },
};

export const variantsNav = {
  visible: { y: 0, background: 'none' },
  hidden: { y: -100, background: '#46464638' },
};

export const opacity = {
  initial: {
    opacity: 0,
  },

  open: {
    opacity: 1,
    transition: { duration: 0.25 },
  },

  closed: {
    opacity: 0,
    transition: { duration: 0.25 },
  },
};

const transition = { duration: 1, ease: [0.76, 0, 0.24, 1] };

export const height = {
  initial: {
    height: 0,
  },

  enter: {
    height: '100vh',
    background: 'black',
    transition,
  },

  exit: {
    height: 0,
    transition,
  },
};
